import { useEffect, useState } from 'react';

// One shared 1s ticker for every live clock on screen.
const subs = new Set();
let timer = null;
const useNow = (on) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!on) return undefined;
    subs.add(setNow);
    if (!timer) timer = setInterval(() => { const t = Date.now(); subs.forEach((f) => f(t)); }, 1000);
    return () => { subs.delete(setNow); if (!subs.size) { clearInterval(timer); timer = null; } };
  }, [on]);
  return now;
};

const MAX_RUN = 40; // ESPN stops the clock for fouls/timeouts — never run more than this past the last update
const fmt = (s) => (s < 60 ? s.toFixed(1) : `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`);

// "Q4 · 10:58" counting down between refreshes; HALF / END Q3 / OT labels pass through unchanged.
export const tickedLabel = (label, sec, at, running, now) => {
  const base = String(label || '');
  if (!running || sec == null || !at || !base.includes(' · ')) return base;
  const ran = Math.min(MAX_RUN, Math.max(0, (now - Date.parse(at)) / 1000));
  const left = Math.max(0, Number(sec) - ran);
  return `${base.split(' · ')[0]} · ${fmt(left)}`;
};

export const useLiveClock = (label, sec, at, running) => tickedLabel(label, sec, at, running, useNow(!!running));
